import 'react-app-polyfill/ie11';
import 'core-js/stable';
import React from 'react';
import HoneywellLogo from '../images/svgLatest/footerAeroLogo.svg';
var classNames = require('classnames');


const Footer = ({isMaximised}) => {

  var footerClass = classNames({
    footer: true,
    displayNone: !isMaximised,    
  });
    return (
        <div className={footerClass}>
        { <img alt="Honeywell" className="footerLogo" src={HoneywellLogo} />}
      </div>
    );
}


export default Footer;